<template>
  <template v-if="!isLoading">
    <tbody>
      <tr
        v-for="(row, key) in data"
        :key="key"
        :height="rowHeight + 'px'"
        class="relative border-b border-secondary group cursor-pointer transition-colors"
        :class="{
          'bg-secondary': hoveredRow === row.id,
          '[&>td:first-child]:relative [&>td:first-child]:before:content-[\'\'] [&>td:first-child]:before:absolute [&>td:first-child]:before:left-0 [&>td:first-child]:before:top-0 [&>td:first-child]:before:bottom-0 [&>td:first-child]:before:w-1 [&>td:first-child]:before:bg-utility-error-300':
            showBorderLeft(row),
        }"
        @click="emit('clicked:row', row)"
        @mouseover="emit('hover:row', row.id)"
        @mouseleave="emit('hover:row', null)"
      >
        <td
          v-if="isSelectable"
          class="pl-5"
          @click.stop="$emit('update:selection', row.id, $event)"
        >
          <Checkbox :checked="selectedRows[row.id]" size="sm" />
        </td>
        <DataCell
          v-for="(column, colKey) in visibleColumns"
          :field="column.props.field"
          :data="row"
          :key="`cell-${key}-${colKey}`"
          :style="{ width: column.props.size + 'px' }"
          :class="{ 'pl-3': first(visibleColumns) === column }"
        >
          <template v-if="column.cell" #cell="{ data }">
            <Component :is="column.cell" :data="data" />
          </template>
        </DataCell>
      </tr>
    </tbody>
  </template>
  <template v-else>
    <tbody>
      <tr
        v-for="i of [...Array(10).keys()]"
        :key="i"
        :height="rowHeight + 'px'"
      >
        <td v-if="isSelectable" class="border-b border-secondary pl-5 pr-1">
          <SkeletonCell />
        </td>
        <td
          v-for="(column, colKey) of visibleColumns"
          class="px-2 border-b border-secondary"
          :key="`loading-container-${i}-${colKey}`"
          :class="{ 'pl-3': first(visibleColumns) === column }"
        >
          <SkeletonCell />
        </td>
      </tr>
    </tbody>
  </template>
</template>

<script setup>
import { first } from "lodash";
import { DataCell, SkeletonCell } from "@/SharedComponents/DataGrid";
import { Checkbox } from "@/SharedComponents/Checkboxes";
import { isOverdue } from "@/Utils/tasks";
import { isExpired } from "@/Utils/files";

const emit = defineEmits(["hover:row", "clicked:row", "update:selection"]);

const props = defineProps({
  data: { type: Array, required: true },
  visibleColumns: { type: Array, required: true },
  isSelectable: { type: Boolean, default: false },
  isLoading: { type: Boolean, default: false },
  selectedRows: { type: Object, default: () => ({}) },
  rowHeight: { type: String, default: "60" },
  hoveredRow: { type: String, default: null },
  type: { type: String, required: false },
});

function showBorderLeft(row) {
  switch (props.type) {
    case "assets":
      return row.overdue_tasks_count > 0 || row.expired_files_count > 0;
    case "tasks":
      return (
        isOverdue(row.completed_at, row.scheduled_for) && !row.completed_at
      );
    case "files":
      return isExpired(row.expiration_date);
    default:
      return false;
  }
}
</script>
